import { render, staticRenderFns } from "./workLocus.vue?vue&type=template&id=6bf78b3a&scoped=true"
import script from "./workLocus.vue?vue&type=script&lang=js"
export * from "./workLocus.vue?vue&type=script&lang=js"
import style0 from "./workLocus.vue?vue&type=style&index=0&id=6bf78b3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf78b3a",
  null
  
)

export default component.exports